export default "__VITE_ASSET__8qb1xkNo__"